import './index.scss';

const Hr = () => {
  return <hr />;
};

export { Hr };
